import React, { Component } from 'react'
import Map from './Core'

let rendered = false

export default class Maps extends Component {
    map() {
        Map((google) => {
            if(rendered) return;

            this.googleMaps = google.maps
            this.initMap()
            // rendered = true
        })
    }
    componentDidMount() {
        this.map()
    }
    componentWillReceiveProps(nextProps) {
        if(nextProps.pointers !== this.props.pointers) {
            this.setPointers(nextProps.pointers)
        }
    }

    pointerSelected(id) {
        if(this.props.handleSelected)
        this.props.handleSelected(id)
    }
    pointerClicked(id) {
        if(this.props.handleClicked)
        this.props.handleClicked(id)        
    }

    initMap() {
        let googleMaps = this.googleMaps
        let lat = this.props.lat || 0
        let lng = this.props.lng || 0


        let mapCoordinates = {lat, lng}
        let element = this.refs.map

        this.map = new googleMaps.Map(element, {
            zoom: 7,
            center: mapCoordinates,
            disableDefaultUI: false,
            disableDoubleClickZoom: false,
            draggable: true,
            draggableCursor: false,
            mapTypeControl: false,
            fullscreenControl: false,
            panControl: false,
            scaleControl: false,
            streetViewControl: false,
            zoomControl: true,
            mapTypeId: 'roadmap'
        })


        this.setPointers(this.props.pointers)
        
    }


    setPointers(pointers) {
        let googleMaps = this.googleMaps
        
        let map = this.map
        let icon = require('./pin.svg')
        pointers.forEach(pointer => {
            
            let marker = new googleMaps.Marker({
                position: { lat: parseFloat(pointer.latitude), lng: parseFloat(pointer.longitude)},
                icon,
                map,
                animation: googleMaps.Animation.DROP,
                zIndex: 101
            })

            marker.addListener('mouseover', () => {
                marker.setIcon({
                    url: icon,
                    anchor: new googleMaps.Point(18, 43),
                    scaledSize: new googleMaps.Size(35, 45)
                })
                this.pointerSelected(pointer.id)
            })

            marker.addListener('mouseout', () => {
                marker.setIcon({
                    url: icon,
                    anchor: new googleMaps.Point(15, 38),
                    scaledSize: new googleMaps.Size(30, 40)
                })
                this.pointerSelected(null)
            })

            marker.addListener('click', () => {
                this.pointerClicked(pointer.id)
            })
        });
    }


    render() {
        return (
            <div ref="map" style={{height: this.props.height || '300px', width: '100%', position: 'static'}}>
                {this.props.children}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/third-party/GoogleMap/Maps.js